import React from 'react';
import './css/footer.css';

export default function Footer() {
  var currentYear = new Date().getFullYear();
  return (
    // style={{ height: '90px' }}
    <div className="position-relative" id="footer">
      <div className="footer container">
        <div className="container-fluid">
          <div className="footer-detail row">
            <div className="logo col-sm-5 ">
              <a className="navbar-brand" href="/">
                <img
                  src="assets/logo4-removebg-preview.png"
                  alt="logo"
                  style={{ width: '110px', alignItems: 'center' }}
                />
              </a>
            </div>
            <div className="icons col-sm-7 ">
              <a
                href="https://www.facebook.com/raihanulislam.tomal/"
                rel="noreferrer"
                target="_blank"
                className="icon-decoration"
              >
                <i className="bi bi-facebook"></i>
              </a>
              <a
                href="mailto:raihanultomal@gmail.com"
                rel="noreferrer"
                target="_blank"
                className="icon-decoration"
              >
                <i class="bi bi-envelope-fill"></i>
              </a>
              <a
                href="https://github.com/Raihanultomal"
                rel="noreferrer"
                target="_blank"
                className="icon-decoration"
              >
                <i className="bi bi-github"></i>
              </a>
              <a
                href="https://www.linkedin.com/in/md-raihanul-islam-tomal-a96179228/"
                rel="noreferrer"
                target="_blank"
                className="icon-decoration"
              >
                <i className="bi bi-linkedin"></i>
              </a>
            </div>
          </div>
          <div>
            <p className="copy-right">
              &copy; {currentYear} Md Raihanul Islam Tomal.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
